import React from 'react';
import { SectionHeader, FadeIn } from '../ui';
export function Process() {
  const steps = ['Private consultation', 'Site or block evaluation', 'Design direction', 'Plans and 3D elevations', 'Detailed quotation and selections', 'Build planning and approvals', 'Construction communication', 'Handover and aftercare'];
  return <section className="py-16 md:py-24 bg-atrium-ivory overflow-hidden" data-id="element-301">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-302">
        <FadeIn data-id="element-303">
          <SectionHeader eyebrow="The Path" title="A clearer path from first conversation to handover" data-id="element-304" />
        </FadeIn>

        <div className="relative mt-16" data-id="element-305">
          {/* Desktop horizontal line */}
          <div className="hidden md:block absolute top-6 left-0 right-0 h-[1px] bg-atrium-bronze/30" data-id="element-306" />

          {/* Mobile vertical line */}
          <div className="md:hidden absolute top-0 bottom-0 left-6 w-[1px] bg-atrium-bronze/30" data-id="element-307" />

          <div className="flex flex-col md:flex-row gap-8 md:gap-4 overflow-x-auto pb-8 snap-x hide-scrollbar" data-id="element-308">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 50} className="relative flex-none w-full md:w-48 snap-start pl-16 md:pl-0" data-id="element-309">
                {/* Node */}
                <div className="absolute left-[19px] md:left-0 top-1 md:top-0 w-3 h-3 bg-atrium-bronze rounded-sm rotate-45 md:mt-4.5 z-10" data-id="element-310" />

                <div className="md:pt-12" data-id="element-311">
                  <span className="block text-xs font-bold text-atrium-green mb-2" data-id="element-312">
                    STEP {index + 1}
                  </span>
                  <h4 className="font-serif text-lg text-atrium-ink leading-snug pr-4" data-id="element-313">
                    {step}
                  </h4>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={400} data-id="element-314">
          <p className="text-xs text-atrium-ink/50 mt-8 italic" data-id="element-315">
            Note: Every custom build is unique. Timelines and pricing are
            tailored to your specific design and site requirements.
          </p>
        </FadeIn>
      </div>
    </section>;
}